import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const loginApiSlice = createApi({
    reducerPath: "loginApi",
    baseQuery: fetchBaseQuery({
        baseUrl: "https://policy-parsing.demo.permute.in",
        prepareHeaders: (headers, { getState }) => {
            const token = localStorage.getItem("authToken");
            if (token) {
                headers.set("authorization", "Bearer " + token);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        loginApi: builder.mutation({
            query: (data) => ({ url: "/auth/api/v1/login", method: "POST", body: data }),
        }),
    }),
});

export const { useLoginApiMutation } = loginApiSlice;
